import { useCallback } from 'react';
import { TrackingApi } from 'src/api';
import type { EndOfSessionTrackingAction } from 'src/api/tracking/types';
import { BLOB_TRACKING_DATA } from 'src/apps/LearningSession/BlobSession/tracking';
import { useUserContext } from 'src/context/user';

export type EndOfSessionTrack = (
  action: EndOfSessionTrackingAction,
  trackingData?: Record<string, string>,
) => void;

type EndOfSessionTrackingContext = {
  languagePairId: number | null;
  sessionId: string;
  sessionType: string;
  hasReachedDailyGoal: boolean;
};

export const useEndOfSessionTracking = ({
  languagePairId,
  sessionId,
  sessionType,
  hasReachedDailyGoal,
}: EndOfSessionTrackingContext): EndOfSessionTrack => {
  const { user } = useUserContext();
  const isPro = !!user?.isPro;

  return useCallback(
    (action, trackingData = {}) => {
      void TrackingApi.trackUserAction(action, 'end_of_session_screen', languagePairId, isPro, {
        ...BLOB_TRACKING_DATA,
        session_id: sessionId,
        session_type: sessionType,
        daily_goal_reached: String(hasReachedDailyGoal),
        ...trackingData,
      });
    },
    [languagePairId, isPro, sessionId, sessionType, hasReachedDailyGoal],
  );
};
